export const enTranslations = {
    "home": "Home",
    "community": "Community",
    "writing": "Writing",
    "store": "Store",
    "my_channel": "My Channel",
    "title": "Title",
    "language_settings": "Language Settings",
    "display_language": "Display Language",
    "select_language": "Select Language",
    "korean": "Korean",
    "english": "English",
    "japanese": "Japanese",
    "shipping_info": "Shipping Information",
    "confirm_consent": "I Agree",
    "disagree_consent": "Disagree",
    "enter_shipping": "Enter Shipping Address",
    "check_shipping": "Check Shipping",
    "shipping_preparing": "Shipping is being prepared.",
    "shipping_ready": "Shipping Ready",
    "refund_completed": "Refund Completed",
    "rewards_info": "Rewards Management",
    "personal_info_consent": "Personal Information Collection and Usage Agreement for Prize Delivery",
    "collection_purpose": "Collection and Usage Purpose",
    "delivery_purpose": "Event Prize Delivery and Shipping",
    "retention_period": "Retention Period",
    "retention_duration": "Up to 3 months after prize delivery is completed",
    "collection_items": "Personal Information Collection Items",
    "collection_details": "Name, Phone Number, Delivery Address",
    "agree": "Agree",
    "disagree": "Disagree",
    "next": "Next",
    "complete": "Complete",
    "change_address": "Change Address",
    "delivery_guide": "Product Delivery Guide",
    "guide_1": "Prizes can be received within 2 weeks of entering the delivery address.",
    "guide_2": "You are responsible for any errors in the delivery address.",
    "guide_3_prefix": "For inquiries about prize delivery, please use",
    "guide_3_suffix": ".",
    "account_settings": "Settings",
    "account_settings_title": "Account & Settings",
    "notifications": "Notifications",
    "my_profile": "Profile",
    "logout": "Logout",
    "login_required": "Login is required for this feature.",
    "back_to_login": "Would you like to go to the login screen?",
    "later": "Later",
    "yes": "Yes",
    "attendance": "Check-in",
    "mission_participation": "Challenge",
    "roulette": "Roulette",
    "submit_work": "Submit Work",
    "free_trial": "Free Trial",
    "qualification_test": "Qualification Test",
    "post_news": "Joker News",
    "contact": "Contact",
    "membership": "Membership",
    "followers": "Followers",
    "following": "Following",
    "edit_profile": "Edit Profile",
    "invite_friends": "Invite Friends",
    "level_suffix": "'s Level",
    "daily_mission_title": "Complete daily missions!",
    "app_checkin": "App Check-in",
    "upload_post": "Upload New Post",
    "follow_friend": "Follow a Friend",
    "posts": "Posts",
    "bookmarks": "Bookmarks",
    "likes": "Likes",
    "comments": "Comments",
    "post_type": "Posts",
    "news_type": "News",
    "product_type": "Joker Market",
    "challenge_type": "Challenge",
    "all_type": "All",
    "just_now": "Just now",
    "minute_ago": "1 minute ago",
    "minutes_ago": " minutes ago",
    "hour_ago": "1 hour ago",
    "hours_ago": " hours ago",
    "day_ago": "1 day ago",
    "days_ago": " days ago",
    "week_ago": "1 week ago",
    "weeks_ago": " weeks ago",
    "year_ago": "1 year ago",
    "years_ago": " years ago",
    "remaining_points": "Points needed for next",
    "level_text": "level",
    "grade": "Grade",
    "member_benefits": "Member Benefits",
    "point_history": "Point History",
    "membership_info": "Membership Guide",
    "membership_category": "Category",
    "membership_condition": "Achievement Condition",
    "membership_level_up_points": "Level Up Points",
    "membership_post_points": "Post Points",
    "membership_discount_rate": "Product Discount",
    "membership_like_reward": "Like",
    "membership_comment_reward": "Comment",
    "membership_guest_condition": "Initial\nLevel",
    "accumulated_points": "Accumulated Points",
    "from": "from",
    "point_earning_methods": "How to Earn Points",
    "payment": "Payment",
    "payment_shipping_request": "Payment/Shipping Request",
    "shipping_address_management": "Shipping Address Management",
    "qualification_exam_management": "Qualification Exam Management",
    "notification_settings": "Notification Settings",
    "push_notifications": "Push Notifications",
    "event_ad_recommendation_notifications": "Event/Ad and Recommendation Notifications",
    "announcements": "Announcements",
    "faq": "FAQ",
    "customer_support": "Customer Support",
    "version_information": "Version Information",
    "terms_of_service": "Terms of Service",
    "privacy_policy": "Privacy Policy",
    "app_information_and_policies": "App Information and Policies",
    "login": "Login",
    "payment_shipping_history": "Payment/Shipping History",
    "payment_detail": "Payment Details",
    "prize_registration_complete": "Prize Registration Complete",
    "shipping_in_progress": "Shipping",
    "enter_shipping_info": "Enter Shipping Information",
    "roulette_reward": "Roulette Reward",
    "no_rewards_history": "No rewards history",
    "shipping_scheduled": "Shipping Scheduled",
    "shipping_complete": "Shipping Complete",
    "cancel_return": "Cancellation/Return",
    "exchange_application": "Request Exchange/Return",
    "link_not_exist": "Link does not exist",
    "confirm": "OK",
    "product_purchase": "Product Purchase",
    "point_exchange": "Point Exchange",
    "point_reason": "Reason",
    "no_payment_shipping_history": "No payment/shipping request history",
    "address_name": "Shipping Address Name",
    "address_name_placeholder": "Please enter the shipping address name.",
    "recipient_name": "Recipient Name",
    "recipient_name_placeholder": "Please enter the recipient name.",
    "phone_number": "Phone Number",
    "phone_number_placeholder": "Please enter your phone number.",
    "address": "Address",
    "address_search_placeholder": "Search Address",
    "address_search_button": "Search Address",
    "address_detail_placeholder": "Detailed Address",
    "address_memo": "Address Memo",
    "address_memo_placeholder": "Package storage location, common entrance code, etc.",
    "save": "Save",
    "search": "Search",
    "address_name_error": "Please enter the shipping address name.",
    "address_name_max_error": "Maximum 10 characters allowed.",
    "recipient_name_error": "Please enter the recipient name.",
    "phone_number_error": "Phone number must be 10-11 digits.",
    "address_error": "Please enter the address.",
    "address_max_error": "Address maximum 30 characters allowed.",
    "address_memo_max_error": "Address memo maximum 20 characters allowed.",
    "select": "Select",
    "delete": "Delete",
    "edit": "Edit",
    "no": "No",
    "company": "Company",
    "recipient": "Recipient",
    "delete_address_confirm": "Delete this address?",
    "delete_address_description": "Deleted addresses cannot be recovered,<br />and you need to register a new one.",
    "default_address_set": "Set as default shipping address.",
    "default_address_error": "Failed to set default shipping address.",
    "address_deleted": "Address deleted.",
    "no_registered_address": "No registered addresses.",
    "add_address_prompt": "Please add a shipping address!",
    "add_address": "Add Address",
    "max_address_limit": "Maximum 5 shipping addresses can be registered.",
    "delete_address_to_add": "Delete existing address and add a new one!",
    "change_status": "Change Status",
    "report": "Report",
    "make_private": "Switch to Private",
    "make_public": "Switch to Public",
    "hide_post": "Hide Post",
    "block_user": "Block User",
    "cancel": "Cancel",
    "post_delete_confirm": "Deleted posts cannot be recovered.<br />Are you sure you want to delete?",
    "no_posts": "No posts yet.<br />Be the first to upload a post.",
    "no_challenges": "No active challenges.<br />More fun challenges coming soon!",
    "error_occurred": "An error occurred.. Please try again",
    "no_bookmarks": "No bookmarked posts yet.<br />Bookmark posts you want to keep.",
    "no_likes": "No liked posts yet.<br />Like posts you enjoy.",
    "no_comments": "No comments yet.<br />Connect with friends through comments.",
    "view_all_channel": "View All Channel",
    "coming_soon_title": "Service is under preparation.",
    "coming_soon_description": "This feature is currently in the final development stage and will be reflected in the service soon. Stay tuned!",
    "store_title": "Store",
    "sort_method": "Sort Method",
    "sort_default": "Default",
    "sort_popularity": "Popularity",
    "sort_latest": "Latest",
    "sort_price_asc": "Price: Low to High",
    "sort_price_desc": "Price: High to Low",
    "sort_discount": "Discount Rate",
    "sort_sales": "Most Sales",
    "sort_reviews": "Most Reviews",
    "sort_rating": "Highest Rating",
    "no_products": "No products available.",
    "category": "Category",
    "shipping_fee": "Shipping Fee",
    "coupon": "Coupon",
    "coupon_available_count": "{count} available",
    "coupon_register_or_none": "Register / select coupon",
    "point_use": "Use points",
    "point_use_all": "Use all",
    "point_use_hint": "Balance {balance}P · up to 30% of the product amount ({cap}P)",
    "chk_point_hint_coupon_min_cash": "When you use a coupon, at least 100 won must be paid in cash, so points can't be used with it on this order.",
    "chk_point_hint_no_balance": "You don't have any points.",
    "chk_point_hint_unavailable": "Points can't be used on this order.",
    "chk_coupon_register_link": "+ Add coupon",
    "chk_coupon_applied_of": "1 of {total} available coupons applied",
    "chk_coupon_cancel": "Remove coupon",
    "coupon_discount": "Coupon discount",
    "point_discount": "Point discount",
    "total_payment_amount": "Final payment amount",
    "book_page_locked": "This page is available after purchase",
    "book_buy_now": "Buy now",
    "book_page": "Page",
    "book_prev_page": "Previous page",
    "book_next_page": "Next page",
    "book_zoom_out": "Zoom out",
    "book_zoom_in": "Zoom in",
    "book_not_found": "Product not found.",
    "book_load_error": "Could not load the e-book.",
    "book_viewer_title": "Preview",
    "book_no_pages": "No pages available.",
    "coupon_menu_title": "Register & my coupons",
    "cpn_register_title": "Register paper coupon",
    "cpn_code_placeholder": "8-character coupon number",
    "cpn_code_hint": "Enter the 8-character number on the back of your coupon.",
    "cpn_register_success": "Your {amount} KRW coupon is registered. You can use it at checkout.",
    "cpn_tab_available": "Available",
    "cpn_tab_history": "Used / expired",
    "cpn_sort_available": "Expiring soonest first",
    "cpn_sort_history": "Most recent first",
    "cpn_badge_used": "Used",
    "cpn_badge_expired": "Expired",
    "cpn_badge_voided": "Unavailable",
    "cpn_partner_line": "{partner} partner coupon",
    "cpn_min_order": "Valid on orders of {amount} KRW or more",
    "cpn_all_products": "Valid on all products",
    "cpn_until": "Until {date}",
    "cpn_used_line": "Used on {date}",
    "cpn_used_line_order": "Used on {date} · Order No. {orderId}",
    "cpn_expired_line": "Expired on {date} · Not used",
    "cpn_history_notice": "If you cancel the whole order, coupons that have not expired return to the Available tab.",
    "my_ebooks_page_title": "Purchased e-books",
    "coupon_select_title": "Select coupon",
    "coupon_none_applicable": "No coupons available.",
    "coupon_apply_amount": "-{amount} KRW",
    "coupon_expires_until": "Until {date}",
    "coupon_selected": "Selected",
    "coupon_dont_use": "Do not use a coupon",
    "coupon_go_register": "Go register a coupon",
    "cpk_order_info": "Order total {order} KRW · Only 1 coupon per payment",
    "cpk_none": "Don't use a coupon",
    "cpk_banner": "If the coupon is worth more than your order, the rest will be lost.",
    "cpk_apply": "Apply {amount} KRW discount",
    "cpk_apply_none": "Continue without a coupon",
    "cpk_register": "+ Add coupon",
    "cpk_all_products": "Valid for all products",
    "cpk_close": "Close",
    "cpk_min_order": "Available for payments of {amount} KRW or more",
    "cpk_expires": "~ {date}",
    "chk_product_amount": "Product amount",
    "chk_payment_amount": "Payment amount",
    "chk_title": "Checkout",
    "chk_order_product": "Order Product",
    "chk_ebook_label": "e-book",
    "chk_pay_suffix": "Pay",
    "gate_banner_text": "A new version is available",
    "gate_banner_update": "Update",
    "gate_banner_close": "Close",
    "gate_block_title": "Please update the app",
    "gate_block_body": "This version of the app is no longer supported.\nPlease update to the latest version from the store and open the app again.",
    "gate_block_note": "Your account, points and artworks are safe.\nNew features such as My Room are only available in the latest app.",
    "gate_block_button": "Go to update",
    "gate_block_no_store": "Search for “Joysam Connect” in the app store and update the app.",
    "gate_block_help": "If you cannot update, please ask a parent or guardian for help.\nUpdating may also fail if the device is low on storage or too old.",
    "coupon_register_success": "A {amount} KRW coupon has been registered.",
    "coupon_register_failed": "Could not register the coupon. Please try again later.",
    "coupon_locked_notice": "You can try again in about {minutes} minutes.",
    "coupon_status_used": "Used",
    "coupon_status_expired": "Expired",
    "coupon_status_voided": "Unavailable",
    "coupon_status_available": "Available",
    "coupon_min_order": "Available for purchases of {amount} KRW or more",
    "coupon_none_usable_now": "No coupon is usable right now",
    "coupon_register_title": "Register coupon",
    "coupon_code_label": "Coupon number",
    "coupon_code_placeholder": "8-character coupon number (e.g. J1234567)",
    "coupon_register_button": "Register",
    "coupon_tab_available": "Available",
    "coupon_tab_history": "Used / expired",
    "coupon_load_failed": "Could not load your coupons.",
    "coupon_empty_available": "No coupons available. Register a paper coupon number.",
    "coupon_empty_history": "No used or expired coupons.",
    "load_more": "Load more",
    "my_ebooks_total": "Total",
    "my_ebooks_count_suffix": " books",
    "my_ebooks_sort_label": "Sort",
    "my_ebooks_sort_recent_purchase": "Recently purchased",
    "my_ebooks_sort_recent_read": "Recently read",
    "my_ebooks_sort_title": "Title",
    "my_ebooks_load_error": "Could not load your e-books.",
    "my_ebooks_go_store": "Go to store",
    "my_ebooks_purchased_at": "Purchased",
    "myebooks_completed": "Finished",
    "myebooks_unread": "Not read yet",
    "myebooks_purchased_suffix": "purchased",
    "myebooks_order_no": "Order no.",
    "myebooks_resume": "Continue reading",
    "myebooks_start": "Start reading",
    "myebooks_empty_title": "You have no purchased e-books yet",
    "myebooks_empty_desc": "Purchased e-books will appear here\nso you can read them anytime.",
    "myebooks_browse": "Browse e-books",
    "ebook_menu_title": "Purchased e-books",
    "my_benefits_title": "My assets",
    "ebook_refund_consent": "E-books are hard to refund once you start reading. I have read and understood this.",
    "read_ebook_now": "Read now",
    "my_ebooks_title": "My purchased e-books",
    "my_ebooks_empty": "You have no purchased e-books.",
    "my_ebooks_pages_suffix": " pages",
    "my_ebooks_view_all": "View all",
    "my_ebooks_collapse": "Collapse",
    "ebook_no_shipping": "E-book · No shipping",
    "product_not_found": "Product not found.",
    "currency_won": "KRW",
    "free_shipping_condition": "Free shipping for orders over {threshold} {currency}",
    "free_shipping_remaining": "Add {amount} {currency} more for free shipping",
    "free_shipping_applied": "Free shipping applied",
    "currency_points": "P",
    "product_info": "Product Information",
    "product_details": "Details",
    "product_description": "Product Description",
    "reviews": "Reviews",
    "no_faq": "No FAQ available.",
    "faq_loading_error": "Failed to load FAQs.",
    "no_reviews": "No reviews yet.",
    "product_name": "Product Name",
    "price": "Price",
    "purchase": "Purchase",
    "quantity_select": "Select Quantity",
    "total_amount": "Total Amount",
    "payment_in_progress": "Processing Payment...",
    "payment_method": "Payment Method",
    "order_product": "Order Product",
    "order_checkout": "Order/Checkout",
    "add_address_new": "Add Address+",
    "membership_discount": "Membership Discount",
    "quantity_error": "You have reached the maximum quantity for this product.",
    "membership_discount_info": "*Discount rates vary by JoySam membership level.",
    "cart_max_stock_reached": "The product {name} is already at maximum quantity in your cart.",
    "cart_stock_exceeded": "{name} - You can add at most {n} more of this item to your cart.",
    "total_order_amount": "Total Order Amount",
    "delivery_address": "Delivery Address",
    "prize_guide": "Prize Delivery Guide",
    "customer_service": "Customer Service",
    "quantity_unit": "units",
    "select_delivery_address": "Select Delivery Address",
    "submission_complete": "Submission Complete",
    "payment_failed": "Payment Failed",
    "payment_error_message": "Payment was not completed normally.",
    "retry_instruction": "Please check and try again.",
    "go_to_home": "Go to Home",
    "challenge_thanks": "Thank you for participating in the challenge.",
    "challenge_wish": "We hope you get good results.",
    "product_label": "Product",
    "and_others_count": "and {count} others",
    "order_completed_message": "Order\nCompleted.\n\nThank you.",
    "post_tag": "Post Tags",
    "user_nickname": "User Nickname",
    "product_category": "Product",
    "search_keyword_placeholder": "Enter search keyword...",
    "recommended_keywords": "Recommended Keywords",
    "no_recommended_keywords": "No recommended keywords",
    "search_category": "Search Category",
    "no_search_results": "No search results.",
    "naver_login": "Sign in with Naver",
    "kakao_login": "Sign in with Kakao",
    "google_login": "Sign in with Google",
    "apple_login": "Sign in with Apple",
    "enter_invitation_code": "Enter Invitation Code",
    "account": "Account",
    "quick_login_settings": "Quick Login Settings",
    "other": "Other",
    "withdrawal": "Delete Account",
    "nickname_error": "Please enter a nickname with at least 2 characters.",
    "email_error": "Please enter a valid email format.",
    "phone_error": "Phone number format is incorrect.",
    "file_size_error": "You can only upload files up to 20MB.",
    "saved": "Saved successfully.",
    "nickname_placeholder": "Create a nickname!",
    "edit_profile_image": "Edit Profile Image",
    "select_from_album": "Select photo from album",
    "set_default_image": "Set as default image",
    "english_name_error": "Please enter an English name with at least 2 characters.",
    "korean_name_error": "Please enter a Korean name with at least 2 characters.",
    "age_error": "Please enter age as a number.",
    "experience_error": "Please enter experience as a number.",
    "email_placeholder": "Enter your email address.",
    "korean_name": "Name (Korean)",
    "korean_name_placeholder": "Enter your Korean name.",
    "english_name": "Name (English)",
    "english_name_placeholder": "Enter your English name.",
    "birth_date": "Date of Birth",
    "birth_date_placeholder": "Enter your date of birth.",
    "age_placeholder": "Enter age as a number.",
    "origami_experience": "Origami Experience",
    "numeric_only": "Enter numbers only.",
    "phone_placeholder": "Enter your phone number.",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "check_invitation_code": "Please check your invitation code",
    "points_earned": "Points earned.",
    "invitation_code_instruction": "Enter the invitation code<br />from your friend.",
    "invitation_code_placeholder": "Enter invitation code",
    "register": "Register",
    "email": "Email",
    "copied_to_clipboard": "Copied to clipboard.",
    "my_invitation_code": "My Invitation Code",
    "invite_friends_benefit": "When a friend installs JoySam,<br />both my friend and I get points.",
    "invitation_code_copy_guide": "Select my invitation code area to copy to clipboard.",
    "invitation_code_limit_guide": "You can earn points through invitation codes up to 50 times. If you exceed 50 times, only your friend will earn points.",
    "invite_friends_share_button": "Share",
    "invite_friends_share_message": "Come join me on JoySam! Enter invitation code {code} after signing up and we both get points.",
    "age": "Age",
    "country": "Country",
    "submission_not_completed": "Submission not completed.",
    "pay_submission_fee": "Yes, I'll pay!",
    "feature_under_development": "This feature is under development.<br />We'll be back with amazing updates!",
    "must_pay_before_submit": "You must pay before submitting a new application.",
    "no_active_submission_challenge": "No active work submission challenges.",
    "challenge_fee_notice_part1": "This challenge requires a participation fee of",
    "challenge_fee_notice_part2": "KRW to complete",
    "challenge_fee_notice_part3": "submission.\n\nWould you like to proceed?",
    "featured_posts": "Popular Posts",
    "latest_posts": "Latest Posts",
    "view_more": "View More",
    "joker_market": "Joker Market",
    "joker_market_desc": "Trade your artworks, goods, supplies, and books",
    "board_desc": "Show off your creations",
    "no_related_questions": "No related questions yet.",
    "curious_title": "FAQ",
    "no_faqs_registered": "No FAQs registered.",
    "board": "Posts",
    "newsletter": "News",
    "point_exchange_shop": "Point Exchange",
    "footer_terms_of_service": "Terms & Conditions",
    "footer_company": "Company: Joysam Co., Ltd.",
    "footer_ceo": "CEO: Kyuil Jung",
    "footer_address": "Address: 23F Yongsan Business Center 22, 11 Wonhyo-ro 90-gil, Yongsan-gu, Seoul",
    "footer_business_reg": "Business Reg Number: 503-87-03074",
    "footer_phone": "Phone Number: 070-4621-3262",
    "footer_mail_order_reg": "Mail-order Business Reg: 2026-서울용산-0302",
    "footer_email": "Email: joysam6061@gmail.com",
    "footer_copyright": "© Joysam Connect. All rights reserved.",
    "dm_title": "'s DM",
    "no_conversations": "No conversations",
    "image_text": "[Image]",
    "deleted_message": "[Deleted message]",
    "user": "User",
    "no_notifications": "No new notifications.",
    "attendance_check_in": "Check in",
    "attendance_already_participated": "You have already participated in the check-in mission today. Please visit again tomorrow!",
    "attendance_empty": "Unfortunately, there are no ongoing check-in missions.",
    "congratulations": "Congratulations!",
    "gift_reward_won": "You won a reward!",
    "point_reward_won": "You won points!",
    "attendance_enter_shipping": "Shall we enter the shipping address to receive the reward?",
    "later_input": "Enter later",
    "attendance_confirm": "Confirm",
    "go_back": "Go back",
    "connections_search_placeholder": "Enter nickname...",
    "connections_followers": "Followers",
    "connections_following": "Following",
    "connections_recommendations": "Recommendations",
    "connections_no_search_results": "No search results!",
    "connections_no_followers": "No followers yet.",
    "connections_make_friends": "Make friends with others!",
    "connections_no_following": "Not following anyone yet.",
    "connections_no_users_found": "No users found.",
    "connections_refresh_recommendations": "Refresh Recommendations",
    "follow": "Follow",
    "unfollow": "Unfollow",
    "button_following": "Following",
    "follow_cancelled": "Unfollowed",
    "follow_started": "Followed",
    "follow_status_change_failed": "Failed to change follow status.",
    "bonus_points_earned": "Bonus points earned.",
    "edited_label": "(edited)",
    "leader_label": "Leader",
    "event_roulette": "Roulette",
    "event_attendance": "Daily Check-in",
    "event_free_trial": "Free Trial",
    "event_qualification_test": "Qualification Test",
    "shipping_address_info": "Shipping Address",
    "select_address": "Select Address",
    "registering_address": "Registering address...",
    "roulette_no_missions": "Unfortunately, there are no ongoing roulette missions.",
    "roulette_unlucky": "Too bad!<br/>Please try again next time!",
    "roulette_lucky_points": "Congratulations! You won {points} points!",
    "roulette_lucky_gift": "Congratulations! You won {productName}! Shall we enter the shipping address to receive the reward?",
    "roulette_enter_shipping": "Enter Address",
    "roulette_confirm": "Confirm",
    "roulette_share_title": "Share to Get Extra Spin!",
    "roulette_share_description": "Share to SNS to earn additional roulette spins (Max {maxShares} times daily).<br/>(Current shares: {sharesUsed}/{maxShares})",
    "roulette_share_accept": "Share Now",
    "roulette_share_cancel": "Close",
    "roulette_share_success": "Shared successfully! An extra spin has been granted.",
    "roulette_share_toast_success": "Link copied successfully. 1 additional spin has been added!",
    "level_up_congratulations": "Congratulations! You have achieved {levelName}! {points} points have been earned!",
    "roulette_congratulations": "Congratulations!",
    "roulette_gift_won": "You've won",
    "roulette_gift_reward_address": "Shall we enter the shipping address to receive the reward?",
    "roulette_gift_question": "Want to enter the details?",
    "challenge_event_name": "Challenge/Event Name",
    "roulette_won": "won",
    "personal_info_collection_details": "Personal Information Collection and Usage Details",
    "company_processing_notice": "We process the following work for event execution and prize delivery.",
    "contractor_label": "Contractor",
    "contractor_name": "Hanjin Logistics",
    "contractor_purpose": "Prize shipping",
    "refuse_collection_notice": "You have the right to refuse consent for the collection and use of personal information above. However, if you refuse consent, you will be excluded from participating in the event and receiving services.",
    "shipping_success_message": "Thank you!<br />Your gift is being prepared and will be shipped soon<br />Please continue to check your order information.",
    "withdrawal_title": "Delete Account",
    "withdrawal_confirm_question": "Are you sure you want to delete your account?",
    "withdrawal_content_info": "Here are the contents and points you currently own.",
    "my_posts": "My Posts",
    "my_points": "My Points",
    "scheduled_shipping": "Delivery Scheduled",
    "withdrawal_warning_1": "If you delete your account, all your posts and points will be permanently removed.",
    "withdrawal_warning_2": " Items already scheduled for delivery will still ship, but tracking details may not be available.",
    "withdrawal_button": "Delete",
    "withdrawal_cancel": "Cancel",
    "comment_actions_post": "Comment",
    "comment_delete": "Delete",
    "comment_cancel": "Cancel",
    "comment_banned": "This comment is banned.",
    "comment_deleted_by_admin": "This comment was deleted by an administrator",
    "comment_reported": "This comment is reported.",
    "comment_deleted_by_owner": "The owner deleted this comment.",
    "comment_view_more": "View {count} more comments",
    "comment_hide": "Hide comments",
    "comment_placeholder": "Add a comment...",
    "comment_max_images": "You can only upload up to 5 images.",
    "comment_deleted": "Comment deleted.",
    "comment_created": "Comment created.",
    "comment_reported_submitted": "Report submitted.",
    "comment_hidden": "Comment hidden.",
    "comment_hide_error": "An error occurred while hiding the comment.",
    "post_made_private": "Post switched to private.",
    "post_made_public": "Post switched to public.",
    "user_blocked_success": "User blocked successfully. You will no longer see posts from this user.",
    "user_block_error": "An error occurred while blocking the user.",
    "post_detail_sort": "Sort",
    "challenge_ended": "Challenge Ended",
    "time_remaining": "Time Remaining",
    "today_news": "Today's Joker News",
    "year_unit": "",
    "month_unit": "/",
    "day_unit": "",
    "day_sun": "Sun",
    "day_mon": "Mon",
    "day_tue": "Tue",
    "day_wed": "Wed",
    "day_thu": "Thu",
    "day_fri": "Fri",
    "day_sat": "Sat",
    "view_post_detail": "View Post Details",
    "join_mission": "Join Weekly Mission",
    "check_winner": "Check Winner",
    "participation_complete": "Participation Complete",
    "post_reported_success": "Post reported successfully.",
    "product_selling": "Selling",
    "product_reserved": "Reserved",
    "product_sold": "Sold",
    "status_changed": "Status changed to",
    "status_changed_suffix": ".",
    "status_change_failed": "Failed to change status",
    "no_comments_yet": "No comments yet",
    "be_first_commenter": "Be the first to comment.",
    "submit_additional": "Submit Additional",
    "submit_payment": "Make Payment",
    "yes_payment": "Yes, I'll pay!",
    "challenge_fee_submission_part1": "This challenge requires a participation fee of",
    "challenge_fee_submission_part2": "to be paid",
    "challenge_fee_submission_part3": "to complete your submission.",
    "challenge_fee_submission_part4": "Do you want to participate?",
    "submission_not_completed_button": "Submission is not complete.",
    "challenge_fee_part1": "This challenge has",
    "challenge_fee_part2": "participation fee",
    "challenge_fee_part3": "and is a paid challenge.",
    "yes_proceed": "Yes, let's proceed!",
    "no_button": "No",
    "challenge_fee_refund_part1": "If you don't participate in the challenge after payment,",
    "challenge_fee_refund_part2": "a full refund will be processed after the challenge period ends",
    "challenge_fee_refund_part3": ".",
    "challenge_fee_refund_part4": "Do you want to continue?",
    "draft_continue_confirm": "Do you want to continue writing the saved submission information?",
    "draft_new_info": "If you write new submission information,",
    "draft_info_disappear": "the saved content will be deleted.",
    "draft_saved_at": "saved at",
    "draft_has_content": "has submission content.",
    "draft_create_new": "Create New",
    "draft_continue_writing": "Continue Writing",
    "multi_submit_challenge_info": "This is a challenge where multiple submissions are allowed,",
    "submit_count_unlimited": "and you can participate regardless of the number of submissions.",
    "challenge_participate_confirm": "Do you want to participate?",
    "already_participated": "You have already participated in this challenge.",
    "yes_submit_additional": "Yes, I'll submit additional!",
    "something_went_wrong": "Something went wrong",
    "make_payment": "Make Payment",
    "payment_info": "Payment Information",
    "payment_method_selection": "Payment Method",
    "agree_payment_terms": "I agree to the payment terms and conditions",
    "payment_cancel_notice": "Payment cancellation is only possible within 7 days from the payment date.",
    "minor_consent_notice_part1": "For minors, parental consent is required when making a payment,",
    "minor_consent_notice_part2": "and I confirm that I have obtained parental consent.",
    "electronic_payment_terms": "Electronic Payment Transaction Terms and Conditions",
    "chapter1_general": "Chapter 1: General Provisions",
    "article1_purpose": "Article 1 (Purpose) These terms and conditions are intended to define the rights, obligations, responsibilities, and other necessary matters between users and service providers using this service.",
    "article2_definitions": "Article 2 (Definitions)",
    "article2_service": "\"Service\" means various services provided by the company.",
    "article2_user": "\"User\" means a person who agrees to these terms and conditions and uses the services provided by the company.",
    "chapter2_service_contract": "Chapter 2: Service Agreement",
    "chapter2_content": "1. A service agreement is concluded when a user agrees to the terms and conditions and submits the registration form as determined by the company. Users must provide all information accurately and truthfully when applying for the service.",
    "chapter3_service_use_management": "Chapter 3: Service Use and Management",
    "article4_provision_change": "Article 4 (Service Provision and Modification)",
    "article4_content1": "The company may provide services to users, and the content of the services provided is subject to the company's policies.",
    "article4_content2": "The company may modify the content of services as necessary for operational or technical reasons.",
    "article5_interruption": "Article 5 (Service Interruption)",
    "article5_content": "The company may suspend all or part of the service in any of the following cases: a. During regular or irregular server maintenance, b. In case of force majeure such as natural disasters, wars, terrorism, or significant operational accidents.",
    "points_exchange_notice": "You can exchange points collected for Origami products.",
    "all_categories": "All",
    "points_highest": "Highest Points",
    "points_lowest": "Lowest Points",
    "points_sort_title": "Sort",
    "login_info_error": "Cannot retrieve login information.",
    "contact_support": "Please contact customer support.",
    "register_again_confirm": "Do you want to register again?",
    "account_unavailable": "Your account is not available",
    "login_with_naver": "Login with Naver",
    "login_with_kakao": "Login with Kakao",
    "login_with_google": "Login with Google",
    "login_with_apple": "Login with Apple",
    "post_updated": "Post has been updated.",
    "max_media_count": "You can upload a maximum of 10 images.",
    "file_too_large": "You can upload images up to 10MB maximum.",
    "caption_required": "Please enter content.",
    "tags_required": "Please enter at least 1 tag.",
    "media_required": "Please add images or videos.",
    "tag_max_length_error": "Please enter tags with 50 characters or less.",
    "changes_lost": "All changes will be lost.<br />Do you want to leave the edit page?",
    "select_group": "Select Group",
    "video_url_input": "Enter Video URL",
    "sort": "Sort",
    "select_photos_videos": "Select photos/videos from gallery",
    "register_video_by_url": "Register Video by URL",
    "attach": "Attach",
    "board_selection": "Select Board",
    "type": "Type",
    "image_type": "Image",
    "video_url_type": "Video URL",
    "default_group": "Default",
    "product_name_placeholder": "Please enter product name.",
    "content_placeholder": "Please enter content.",
    "tag_input": "Tag Input",
    "tag_placeholder": "Please enter tags.",
    "tag_input_button": "Add",
    "max_tags_error": "You can add up to {count} tags.",
    "price_input": "Price Input",
    "price_placeholder": "Please enter amount.",
    "url_label": "URL",
    "url_placeholder": "Enter URL (https://youtube.com)",
    "url_check_button": "Check",
    "url_error_message": "The link address is not correct.",
    "youtube_support_info": "Currently only YouTube videos are supported.",
    "youtube_share_instruction": "Please click the share button on YouTube and enter the provided URL.",
    "url_preview_instruction": "Click the check button to verify that the preview is displayed correctly.",
    "challenge_available": "There are",
    "challenge_count_unit": "challenges",
    "challenge_available_suffix": "available!",
    "bonus_points_earned_title": "{points} points have been earned.",
    "points_of_user": "'s Points",
    "unknown_user": "UNKNOWN",
    "no_blocked_users": "No blocked users.",
    "blocked_at": "Blocked on",
    "unblock": "Unblock",
    "unblock_confirm": "Unblock this user?",
    "unblock_confirm_description": "{nickname} will be unblocked.",
    "unblock_success": "User unblocked.",
    "unblock_error": "Failed to unblock user.",
    "blocked_user_unknown_nickname": "Unknown user",
    "blocked_users_management": "Blocked users",
    "view_store_products": "See what you can get",
    "retry": "Retry",
    "write_first_post": "Write the first post",
    "clear_filter": "Clear filters",
    "no_products_for_filter": "No products match '{condition}'.",
    "failed_to_load_list": "Failed to load the list.",
    "browse_store": "Browse the store",
    "privacy_management": "Blocking",
    "user_default_name": "User",
    "message_send_failed": "Failed to send message.",
    "image_send_failed": "Failed to send image.",
    "no_messages": "No messages",
    "message_media_alt": "Message media",
    "image_upload_limit": "You can only upload up to 10 images.",
    "message_input_placeholder": "Send a message...",
    "blocked_user_message": "You cannot send messages to a blocked user",
    "message_send_error": "Failed to send message.",
    "post_author": "Author",
    "challenges_all": "All",
    "challenges_participable": "Can Participate",
    "challenges_participated": "Already Participated",
    "select_inquiry_period": "Select Inquiry Period",
    "read_more": "... Read More",
    "show_less": "Hide",
    "order_number": "Order Number",
    "order_date": "Order Date",
    "point_exchange_product": "Point Exchange Product",
    "quantity": "Quantity",
    "tracking_code": "Tracking Code",
    "no_tracking_code": "No tracking code",
    "tracking_code_preparing": "Preparing Tracking Code",
    "order_cancelled": "Order Cancelled",
    "total_payment": "Total Payment",
    "total_exchange_points": "Total Exchange Points",
    "rating": "Rate this product",
    "select_rating": "Please select a rating.",
    "product_info_missing": "Product information is missing.",
    "rating_saved": "Rating saved.",
    "rating_save_failed": "Failed to save rating.",
    "loading_rating_info": "Loading rating information...",
    "saving": "Saving...",
    "shipping_address": "Delivery Address",
    "insufficient_points": "Insufficient Points",
    "insufficient_points_message": "If you don't have enough points,",
    "participate_challenge": "Participate in point-earning challenges",
    "participate_challenge_suffix": "!",
    "exchange_button": "Exchange",
    "insufficient_points_exchange": "You don't have enough points to exchange this product.",
    "exchange_address_submit_failed": "Failed to submit shipping address for prize.",
    "exchange_address_submit_failed_message": "Please try again, or contact customer service if the problem persists.<br />Thank you.",
    "exchange_return_policy": "If you wish, we will refund the points for the purchased product. However, returns are not possible in the following cases:",
    "exchange_policy_1": "If more than 7 days have passed since receiving the product",
    "exchange_policy_2": "If the received product is opened and cannot be resold",
    "exchange_product": "Exchange Product",
    "personal_info_collection_consent": "Consent for Personal Information Collection and Use for Product Receipt",
    "field_required_template": "Please enter $항목명$.",
    "address_detail": "Detailed Address",
    "prize_receipt_not_possible": "Prize receipt is not possible.",
    "personal_data_not_agreed": "If you do not agree to the collection and use of personal information,<br />the prize cannot be sent.",
    "exchange_complete": "Exchange Complete!",
    "exchange_success_message": "Thank you! <br />Your gift is being prepared and will be sent soon.<br />Please continue to check your order information.",
    "enter_shipping_address": "Enter Shipping Address",
    "agree_personal_info_collection": "Do you agree to the collection and use of personal information as above?",
    "change_shipping_address": "Change Shipping Address",
    "add_shipping_address": "Add Shipping Address +",
    "submit": "Submit",
    "privacy_info_title": "Personal Information Collection and Use Details",
    "collection_purpose_text": "Event Prize Fulfillment and Shipping",
    "retention_period_text": "Up to 3 months after prize fulfillment",
    "personal_info_items": "Personal Information Collection Items",
    "personal_info_items_text": "Name, Phone Number, Delivery Address",
    "company_process_text": "We will handle business as follows for event promotion and prize fulfillment:",
    "contractor": "Contractor",
    "contractor_names": "Hanjin Logistics",
    "purpose": "Purpose",
    "purpose_text": "Prize Shipping",
    "refusal_notice": "You have the right to refuse consent to the collection and use of personal information above. However, if you refuse consent, you will be excluded from event promotion and service provision.",
    "product_receipt_notice": "Product Receipt Notice",
    "receipt_within_two_weeks": "Prizes can be received within 2 weeks after entering the delivery address.",
    "wrong_address_responsibility": "Any errors in the delivery address are the responsibility of the winner.",
    "inquiry_about_prize": "For inquiries about prize shipment, please use",
    "to_use": ".",
    "exchange_success_completed": "Product exchange has been completed successfully",
    "received": "Received",
    "no_points_yet": "You don't have any points yet.",
    "exchange": "Exchanged",
    "seller_info_not_found": "Cannot find seller information.",
    "dm_button": "DM",
    "user_channel": "'s channel",
    "send_dm": "Send DM",
    "follow_button": "Follow",
    "group": "Group",
    "user_deleted_msg": "User has been deleted.",
    "user_suspended_msg": "User has been suspended.",
    "user_payment_cancelled_msg": "User has cancelled the payment.",
    "points_deduction_confirmation": "{points} points will be deducted",
    "insufficient_points_title": "Insufficient Points",
    "insufficient_points_message_2": "You don't have enough points.\nEarn more points through more activities!",
    "agree_all_terms": "I Agree to All",
    "you_can_use_service_even_without_optional_agreement": "You can use the service even if you disagree with the optional items.",
    "terms_of_service_agreement": "Terms of Service Agreement (Required)",
    "privacy_policy_agreement": "Personal Information Collection and Usage Agreement (Required)",
    "age_confirmation": "I am over 14 years old.",
    "check_terms_of_service": "Please check the Terms of Service.",
    "setup_email_title": "Please set up your email.",
    "email_label": "Email",
    "email_address_placeholder": "Please enter your email address.",
    "setup_phone_title": "Please enter your phone number.",
    "phone_number_label": "Phone Number",
    "phone_number_input_placeholder": "Please enter your phone number.",
    "invalid_phone_number_error": "Please enter a valid phone number.",
    "optional_notice": "This is optional and you can use the service without agreeing to it.",
    "setup_referrer_title": "Please enter a referrer's nickname.",
    "nickname_label": "Nickname",
    "referrer_nickname_placeholder": "Please enter the referrer's nickname.",
    "nickname_does_not_exist_error": "This nickname does not exist.",
    "referrer_optional_notice": "This is optional. You will receive {referralPoints} points upon first registration.",
    "setup_personal_info_title": "Please enter your personal information.",
    "age_label": "Age",
    "age_input_placeholder": "Please enter your age as a number.",
    "birthdate_label": "Date of Birth",
    "select_birthdate": "Please select your date of birth.",
    "birthdate_placeholder": "Please enter your date of birth.",
    "origami_experience_label": "Origami Experience",
    "personal_info_optional_notice": "This is optional. You will receive {updateProfilePoints} points upon first registration.",
    "setup_profile_title": "Please set up your profile.",
    "image_upload_help_text": "Please upload an image with a size of 1200x810px.",
    "sold_out": "Sold Out",
    "cart_added_success": "Item added to cart.",
    "continue_shopping": "Continue shopping",
    "go_to_cart": "Go to cart",
    "un_authentication_message": "Login is required.<br /><br />Go to login screen?",
    "total_amount_per_item": "Total amount",
    "order_product_total": "Order Product Total",
    "membership_discount_with_percent": "Membership Discount {percent}%",
    "select_option": "Please select an option.",
    "add_to_cart": "Add to cart",
    "buy_now": "Buy now",
    "cart_title": "Cart",
    "cart_empty": "Your cart is empty.",
    "order_confirmation_title": "Order Confirmation",
    "buy_all_items_confirm": "Are you sure you want to buy all {count} items in your cart?",
    "select_all_with_count": "All ({count})",
    "delete_all": "Delete All",
    "delete_selected_item_confirm": "Are you sure you want to delete the selected product?",
    "delete_selected": "Delete Selected",
    "total_product_amount": "Total Product Amount",
    "total_shipping_fee": "Total Shipping Fee",
    "estimated_payment_amount": "Estimated Payment Amount",
    "buy_all_products": "Buy All Products",
    "buy_selected_products": "Buy Selected Products",
    "follow_success": "Followed successfully.",
    "unfollow_success": "Unfollowed successfully.",
    "point_earned_like": "Points earned for liking content.",
    "point_earned_comment": "Points earned for commenting.",
    "onboarding_board_description": "See origami works shared by friends\nand tips from experts\nall in one place.",
    "onboarding_joker_market_description": "Show off origami you made,\nand sell it at the price you want.",
    "onboarding_newsletter_description": "Get JoySam's news and expert origami\ninformation quickly.",
    "onboarding_follow_description": "Follow friends you connect with\nand share each other's\norigami updates.",
    "onboarding_store_description": "Easily and conveniently buy\na variety of origami supplies.",
    "onboarding_skip": "Skip",
    "onboarding_get_started": "Get Started",
    "login_token_expired": "Your login session has expired. Please log in again.",
    "server_response_unavailable": "Unable to get a response from the server. Please try again.",
    "server_response_data_missing": "The server response is missing required data.",
    "profile_nickname_placeholder": "Please create a nickname!",
    "required_badge": "(Required)",
    "not_logged_in_title": "You are not logged in.",
    "go_to_login_confirm": "Would you like to go to the login page?",
    "joker_event_section_title": "Joker Event",
    "myroom_banner_aria_label": "Decorate your origami room — Go to My Room",
    "myroom_banner_alt": "Decorate your origami room - Display your own origami works in a 3D space.",
    "myroom_card_accent": "My Room",
    "myroom_card_title_linked": "My 3D Space",
    "myroom_card_title_new": "Decorate your origami room",
    "myroom_card_title_onboarding": "Sign-up isn't finished",
    "myroom_card_subtitle": "Display your own origami in a 3D space.",
    "myroom_card_cta_linked": "Go to My Room",
    "myroom_card_cta_new": "Go decorate My Room",
    "myroom_card_cta_onboarding": "Continue My Room sign-up",
    "myroom_card_item_badge": "Your 3D item is ready",
    "myroom_card_item_done_title": "3D item ready",
    "myroom_card_item_done_message": "{name} is ready.\nWould you like to place it?",
    "myroom_card_item_later": "Later",
    "myroom_card_item_place": "Place it",
    "myroom_cash_title": "Convert points to My Room cash",
    "myroom_cash_sub_min": "Available from {min}P",
    "myroom_cash_sub_balance": "You have {points}P → {cash}C if you convert now",
    "store_cat_best": "Best",
    "store_cat_origami_books": "Origami Books",
    "store_cat_colored_paper": "Origami Paper",
    "store_cat_other_tools": "Other Tools",
    "store_cat_sets": "Sets",
    "pending_deposit_one": "You have an order waiting for payment",
    "pending_deposit_many": "You have {count} orders waiting for payment",
    "see_account": "View account",
    "myroom_misc_update_title": "App update required",
    "myroom_misc_update_message": "My Room is available in the latest version of the app.\nPlease update JoySam Connect in the App Store.",
    "myroom_frame_err_invalid_assertion": "The connection info is not valid.\nPlease try again.",
    "myroom_frame_err_expired_assertion": "The connection info has expired.\nPlease try again.",
    "myroom_frame_err_network": "The connection is unstable.\nPlease try again in a moment.",
    "myroom_frame_err_server": "My Room is having a temporary problem.\nPlease try again in a moment.",
    "myroom_frame_err_unknown": "Please try again in a moment.",
    "myroom_frame_rejected_withdrawn_title": "This My Room account was deleted",
    "myroom_frame_rejected_withdrawn_body": "You cannot connect again for 14 days after leaving.",
    "myroom_frame_rejected_fallback_title": "Cannot connect to My Room",
    "myroom_frame_rejected_fallback_body": "This account cannot connect right now.\nPlease contact customer support.",
    "myroom_frame_date_fmt": "{m}/{d}",
    "myroom_frame_can_reconnect": "You can connect again from {date}.",
    "myroom_frame_can_reconnect_days": "You can connect again from {date} (in {days} days).",
    "myroom_frame_sample_info_failed": "Could not load the sample room info.",
    "myroom_frame_sample_load_failed": "Could not load the sample room.",
    "myroom_frame_enter_info_failed": "Could not load the room entry info.",
    "myroom_frame_enter_failed": "Could not enter the room.",
    "myroom_frame_connecting": "Connecting to My Room…",
    "myroom_frame_session_failed": "Could not set up the session.",
    "myroom_frame_session_error": "Something went wrong while setting up the session.",
    "myroom_frame_connected": "Connected to My Room",
    "myroom_frame_link_done": "Your My Room link is complete",
    "myroom_frame_already_linked": "Already linked",
    "myroom_frame_link_expired": "The link time ran out. Please try again",
    "myroom_frame_connect_failed_retry": "Could not connect to My Room. Please try again in a moment.",
    "myroom_frame_connect_failed": "Could not connect to My Room.",
    "myroom_frame_consent_title": "Link My Room",
    "myroom_frame_consent_existing_1": "You already have a My Room account.",
    "myroom_frame_consent_existing_2": "If you continue, your JoySam account will be linked to it and you will go to your room.",
    "myroom_frame_consent_new_1": "Start My Room with your JoySam account.",
    "myroom_frame_consent_new_2": "If you continue, your JoySam account will be linked to My Room.",
    "myroom_frame_consenting": "Connecting…",
    "myroom_frame_agree_existing": "Agree and go to my room",
    "myroom_frame_agree_new": "Agree and start",
    "myroom_frame_back": "Go back",
    "myroom_frame_back_aria": "Back to JoySam",
    "myroom_frame_friend": "Your friend",
    "myroom_frame_friend_not_started": "{name} has not\nstarted My Room yet",
    "myroom_frame_title_link_needed": "My Room link needed",
    "myroom_frame_title_login_needed": "Login required",
    "myroom_frame_title_cannot_open": "Cannot open the room",
    "myroom_frame_desc_unavailable": "You can visit the room once your friend starts My Room.",
    "myroom_frame_desc_login": "Please log in again, then come back to My Room.",
    "myroom_frame_desc_link_required": "My Room starts with a Google, Kakao, Apple or LINE account.\nIf you signed up with Naver, please choose one of them.\nYour JoySam account and activity stay the same.\n\nOnce you finish logging in on the browser, you will come right back.",
    "myroom_frame_desc_social_required": "My Room connects with a Google, Kakao, Apple or LINE account.\nLog in with one of them\nto use My Room.",
    "myroom_frame_btn_finish_signup": "Finish My Room sign-up",
    "myroom_frame_btn_my_room": "Go to my room",
    "myroom_frame_btn_link": "Link My Room",
    "myroom_frame_btn_social_login": "Log in with a social account",
    "myroom_frame_btn_login": "Log in",
    "myroom_frame_btn_retry": "Try again",
    "myroom_frame_browser_hint": "Did the browser not open?\nCopy the address and paste it into Chrome or Samsung Internet.\nYou can also log in to JoySam on a PC to link.",
    "myroom_frame_copied": "Copied",
    "myroom_frame_copy_link": "Copy link address",
    "myroom_frame_loading_room": "Loading the room…",
    "bottom_nav_modal_confirm": "Confirm",
    "expert_channel_section_title": "Expert Channel with Joysam",
    "expert_channel_empty_message": "No experts have been registered yet.<br />Be active and become the first expert.",
    "content_slider_exam_title": "Ongoing Certification Exam",
    "content_slider_exam_content": "Please study for the 2024 Korea 'Children's Origami Level 3' certification exam...",
    "popular_posts_section_title": "Buzzing Community Posts",
    "popular_posts_empty_message": "No popular posts written in the last 12 hours.",
    "certificate_application": "Certificate Application",
    "payment_complete_status": "Payment Complete",
    "product_prep_status": "Preparing Product",
    "shipping_start_status": "Shipping Started",
    "vbank_share_title": "[JoySam Connect] Deposit Info",
    "depositor": "Depositor",
    "deposit_amount": "Deposit Amount",
    "deposit_deadline": "Deposit Deadline",
    "until": "until",
    "smart_delivery_tracking": "Smart Delivery Tracking",
    "order_cancel_confirm_title": "Are you sure you want to cancel this order?",
    "order_cancel_confirm_message": "If you cancel this order, refunds take about 3–5 business days depending on your card issuer.",
    "order_cancel_done_title": "Your order has been canceled",
    "order_cancel_done_message": "A refund of your payment has been requested.<br />Refunds take about 3–5 business days depending on your card issuer.",
    "payment_form_load_error": "Failed to load the payment window. Please try again.",
    "payment_form_submit_title": "Submit Payment Form",
    "nickname_fallback_default": "User",
    "order_cancel": "Cancel Order",
    "save_complete_title": "Saved successfully",
    "withdrawal_error": "An error occurred while withdrawing your membership.",
    "congrats_bonus_points_title": "Congratulations!<br>{points} points have been earned!",
    "marketing_consent_notice": "As of {month}/{day}/{year}, you have {consent} to receive marketing information provided by JoySam.",
    "marketing_consent_agreed": "agreed",
    "marketing_consent_disagreed": "not agreed",
    "submit_work_step_photo_registration": "Register Work Photos",
    "login_required_confirm_message": "You are not logged in. Please log in to continue.<br/>Would you like to go to the login screen?",
    "temp_save_success": "Saved as draft.",
    "unsupported_image_format": "This image format is not supported",
    "field_title_ko": "Title (Korean)",
    "field_title_en": "Title (English)",
    "field_width": "Width",
    "field_height": "Height",
    "field_length": "Depth",
    "field_description": "Work Description",
    "field_work_type": "Work Type (Shape)",
    "field_number_of_paper": "Number of Sheets Used",
    "field_used_paper_shapes": "Paper Shape Used",
    "field_has_cut_marks": "Cut Marks",
    "field_is_glued": "Glued",
    "field_finished_shape": "Finished Shape Status",
    "field_primary_folding_method": "Basic Type",
    "field_target_age": "Target Age (Difficulty)",
    "field_submitter_name_ko": "Name (Korean)",
    "field_submitter_name_en": "Name (English)",
    "field_birthdate": "Date of Birth",
    "field_country": "Country",
    "field_address1": "Address",
    "field_address2": "Detailed Address",
    "field_mobile": "Mobile Number",
    "field_phone": "Phone Number",
    "field_email": "Email",
    "field_social_media_url": "SNS Address",
    "field_gender": "Gender",
    "field_is_creator": "I am the creator",
    "field_co_maker": "Co-creation Status",
    "field_required_suffix": "Please enter this field.",
    "submit_button": "Submit",
    "submit_work_title": "Submit Work",
    "temp_save": "Save Draft",
    "leave_without_saving_title": "Leave without saving changes?",
    "leave_without_saving_description": "Your input will be saved as a draft.",
    "submit_photo_face": "Front",
    "submit_photo_back": "Back",
    "submit_photo_left": "Left Side",
    "submit_photo_right": "Right Side",
    "unsupported_image_format_title": "{file} of the {name} image is not a supported image format.",
    "max_5_photos_limit": "You can register up to 5 photos/videos only.",
    "option_has": "Yes",
    "option_none": "No",
    "select_target_age_title": "Select Target Age (Difficulty)",
    "select_completed_state_title": "Select Finished Shape Status",
    "select_basic_type_title": "Select Basic Type",
    "select_paper_shape_title": "Select Paper Shape Used",
    "placeholder_input_korean": "Please enter in Korean.",
    "placeholder_input_english": "Please enter in English.",
    "field_work_dimension": "Work Dimensions (cm)",
    "dimension_range_error": "Please enter a number between 0.01 and 10000.",
    "placeholder_work_shape_description": "Please describe the shape, e.g. animal/dinosaur/plant/vehicle/character/building/ruins/shape/symbol/letter/insect/fish, etc.",
    "placeholder_input_paper_count": "Please enter the number of sheets used.",
    "placeholder_select_paper_shape": "Please select a paper shape.",
    "placeholder_input_finished_shape": "Please enter the finished shape status.",
    "placeholder_input_basic_type": "Please enter the basic type.",
    "placeholder_input_target_age": "Please enter the target age (difficulty).",
    "placeholder_numbers_only": "Please enter numbers only.",
    "placeholder_input_mobile": "Please enter your mobile number.",
    "placeholder_input_email": "Please enter your email.",
    "placeholder_input_sns_url": "Please enter your SNS address.",
    "gender_male": "Male",
    "gender_female": "Female",
    "checkbox_is_creator": "I am the creator.",
    "required_marker": "(Required)",
    "submitter_legal_responsibility_notice": "If this is not you, legal responsibility lies with the submitter, and the award may be cancelled.",
    "privacy_consent_notice_html": "<p style=\"font-weight: 700; font-size: 12px; margin-top: 0; margin-bottom: 20px\">Additional personal information is collected when you participate in the contest.</p><p style=\"font-weight: 400; font-size: 12px; margin-top: 0; margin-bottom: 20px\">JoySSing processes personal information for the following purposes under Article 30 of the Personal Information Protection Act. The information processed will not be used for any purpose other than those stated below, and if the purpose of use changes, necessary measures such as obtaining separate consent will be taken under Article 18 of the same Act.</p><div><span>Details of Personal Information Collection and Use</span><ul><li>Purpose of collection and use: Identification of participants for contest entry</li><li>Retention period: Retained for 5 years from the date of participation (Act on Consumer Protection in Electronic Commerce, etc.)<br/>However, information separately retained under relevant laws and company policy is an exception</li><li>Items collected: Name, mobile phone number, delivery address</li></ul></div><div><span>Items of Personal Information Collected</span><ul><li>Required: Name (Korean), Name (English), date of birth, mobile phone number, address</li><li>Optional: Gender, phone number, email, SNS address, co-creator information</li></ul></div><span>You have the right to refuse consent to the collection and use of the personal information above. However, if you refuse, you may be restricted from receiving services related to this event.</span>",
    "privacy_consent_confirm_question": "Do you agree to the collection and use of personal information as described above?",
    "select_country_title": "Select Country",
    "co_maker_alone": "I did it alone",
    "co_maker_together": "I did it together",
    "field_co_maker_name_ko": "Co-creator Name (Korean)",
    "placeholder_co_maker_name": "Please write in the format Name(Affiliation). Separate multiple names with commas.",
    "seconds_unit": "sec",
    "free_trial_coming_soon_title": "The free trial service is being prepared.",
    "qualification_test_coming_soon_title": "The qualification test service is being prepared.",
    "my_points_amount_line": "My points: {amount}P",
    "points_remaining_line": "{remain}P to go for the {lowest}P item",
    "no_news_registered": "No news has been registered",
    "shipping_modal_default_description": "Paper World, Science World",
} as const;

export type EnTranslationKeys = keyof typeof enTranslations;
